module.exports = __webpack_public_path__ + "static/media/2015_maleRate_femaleRate.263ea6a5.png";